module.exports = __webpack_public_path__ + "background.b0c62bb.png";